import { Grid } from '@material-ui/core';
import { useEffect, useState, useContext } from 'react';
import { MandatoryField } from '../../../../Core/FormInput/inputfields';
import { SecondaryButton } from '../../../../Core/FormInput';
import { postMADashboard_CopyDashboard } from '../../../../Core/Service/ManageAccount/manageAccountService';
import AppContext from '../../../../App/AppContext';

const CopyDashboardModal = (props) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({ mADashboardName: '', errors: {}, isError: false, isError2: false });

    const validate = () => {
        let errors = {};
        let isValid = true;
        if (!state.mADashboardName) {
            isValid = false;
            errors.mADashboardName = 'This field is required';
        }
        setState((st) => ({ ...st, errors: errors }));
        return isValid;
    };
    const handleData = async () => {
        if (validate()) {
            const data = {
                copyMADashboardID: props.selectedRowData.maDashboardID,
                mADashboardName: state.mADashboardName
            };

            try {
                const res = await postMADashboard_CopyDashboard(data);
                if (res.success) {
                    showToast('Dashboard copied successfully');
                    setState((st) => ({
                        ...st,
                        isReload: new Date()
                    }));
                    props.onClose(true);
                } else {
                    showToast(res.message || 'An error occurred');
                }
            } catch (error) {
                showToast('Error copying dashboard');
            }
        }
    };
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} className="mandatory-fields">
                    <MandatoryField
                        autoFocus
                        inputLabel="New Dashboard Name"
                        placeholder="New Dashboard Name"
                        value={state.mADashboardName}
                        inputProps={{ maxLength: 50 }}
                        onChange={(event) => {
                            setState((st) => ({
                                ...st,
                                mADashboardName: event.target.value
                            }));
                        }}
                        errors={state.errors.mADashboardName}
                    />
                </Grid>

                <Grid item xs={12} className="submit_btn">
                    <SecondaryButton onClick={handleData} fullWidth>
                        Copy Dashboard
                    </SecondaryButton>
                </Grid>
            </Grid>
        </>
    );
};
export default CopyDashboardModal;
